<div class="orgbrain-style">
  <ng-container *ngIf="data.imageUrl">
    <div class="image-container">
      <img class="image-style" [src]="data.imageUrl" />
    </div>
    <div class="pb-4"></div>
  </ng-container>

  <orgbrain-dialog-title [title]="data.title" [dialogRef]="data.noCancel ? null : dialogRef">
  </orgbrain-dialog-title>

  <mat-dialog-content class="info-box"
    ><p [innerHtml]="trustedHtml" class="orgbrain-gray-text"></p>
  </mat-dialog-content>
  <div
    [ngClass]="{
      'button-row-full': !layout.mobile,
      'button-col': layout.mobile,
      'mb-pixel-0': true,
    }"
  >
    <ng-container *ngFor="let option of data.options">
      <button
        mat-button
        color="primary"
        cdkFocusInitial
        (click)="select(option.key)"
        [matTooltip]="option.tip"
        [style]="getStyle(option)"
      >
        {{ option.disp }}
      </button>
    </ng-container>
  </div>
</div>
